export default {
  typ: "Typ",
};
